/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState} from 'react'
import {KTIcon} from '../../../../_metronic/helpers'
import NewCategoryModal from '../Modal/NewCategoryModal'
import {Content} from '../../../../_metronic/layout/components/content'
import CategoryListTable from './CategoryListTable'
import {ICategoryList} from '../core/_model'
import DeleteCategory from '../Modal/DeleteCategory'

const Category = () => {
  const [searchTerm, setSearchTerm] = useState('')
  const [selectedCategory, setSelectedCategory] = useState<ICategoryList | null>(null)

  const onSelectCategory = (category: ICategoryList) => setSelectedCategory(category)

  const onDeselectCategory = () => setSelectedCategory(null)

  return (
    <Content>
      <div className='d-flex justify-content-between align-items-center mb-3'>
        <div className='d-flex align-items-center position-relative my-1 w-500px'>
          <KTIcon iconName='magnifier' className='fs-1 position-absolute ms-6' />
          <input
            type='text'
            className='form-control form-control-solid ps-16 rounded-pill py-3 bg-transparent border border-gray-700'
            placeholder='Search by category name'
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <div>
          <button
            type='button'
            className='btn btn-primary'
            data-bs-toggle='modal'
            data-bs-target='#kt_modal_1'
          >
            <KTIcon iconName='plus' className='fs-2' />
            Add New Category
          </button>
        </div>
      </div>

      <CategoryListTable searchTerm={searchTerm} onSelectCategory={onSelectCategory} />

      <NewCategoryModal selectedCategory={selectedCategory} />
      <DeleteCategory selectedCategory={selectedCategory} onDeselectCategory={onDeselectCategory} />
    </Content>
  )
}

export default Category
